import { Folder } from '@/api/generatedApi';
import { StyledList, StyledListItem } from '@/components/AssetsPage/PopoverList';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import EditIcon from '@mui/icons-material/EditOutlined';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import { Divider, ListItemIcon, ListItemText } from '@mui/material';

export const FolderActionsMenuContent = ({
  folder,
  onClose,
  onRenameClick,
  onMoveClick,
  sx,
}: {
  folder: Folder;
  onClose: () => void;
  onRenameClick: (folder: Folder) => void;
  onMoveClick: (folder: Folder) => void;
  sx?: object;
}) => {
  const { permissions } = useGetCurrentUser();

  if (!permissions.canCreateFolders) {
    return;
  }

  const handleRenameClick = () => {
    onRenameClick(folder);
    onClose();
  };

  const handleMoveClick = () => {
    onMoveClick(folder);
    onClose();
  };

  return (
    <StyledList sx={sx}>
      <Divider />
      <StyledListItem onClick={handleRenameClick}>
        <ListItemIcon>
          <EditIcon sx={{ fontSize: '18px' }} />
        </ListItemIcon>
        <ListItemText>Rename Folder</ListItemText>
      </StyledListItem>
      <StyledListItem onClick={handleMoveClick}>
        <ListItemIcon>
          <DriveFileMoveIcon sx={{ fontSize: '18px' }} />
        </ListItemIcon>
        <ListItemText>Move Folder</ListItemText>
      </StyledListItem>
    </StyledList>
  );
};
